import { supabase } from "@/integrations/supabase/client";

function generateEventId(): string {
    return crypto.randomUUID
      ? crypto.randomUUID()
          : Math.random().toString(36).substring(2) + Date.now().toString(36);
}

function getCookie(name: string): string {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : "";
}

// Waits for fbq (Meta Pixel) to be initialized by GTM (which loads async).
// Without this, PageView fires before GTM has run fbq('init') and the event is lost.
async function waitForFbq(maxWaitMs = 5000): Promise<boolean> {
    const start = Date.now();
    return new Promise((resolve) => {
          const check = () => {
                  if (typeof window !== "undefined" && (window as any).fbq) {
                            resolve(true);
                  } else if (Date.now() - start >= maxWaitMs) {
                            resolve(false);
                  } else {
                            setTimeout(check, 100);
                  }
          };
          check();
    });
}

interface TrackEventOptions {
    eventName: "PageView" | "ViewContent" | "Lead";
    email?: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
}

export async function trackMetaEvent(options: TrackEventOptions): Promise<void> {
    const eventId = generateEventId();

  const payload = {
        event_name: options.eventName,
        event_id: eventId,
        event_source_url: window.location.href,
        user_agent: navigator.userAgent,
        fbc: getCookie("_fbc"),
        fbp: getCookie("_fbp"),
        ...(options.email && { email: options.email }),
        ...(options.phone && { phone: options.phone }),
        ...(options.firstName && { first_name: options.firstName }),
        ...(options.lastName && { last_name: options.lastName }),
  };

  // 1. Browser pixel with eventID for deduplication
  // Wait up to 5s for GTM to finish fbq('init') before firing
  const fbqReady = await waitForFbq();
    if (fbqReady) {
          const fbq = (window as any).fbq;
          const customData: Record<string, unknown> = {};
          if (options.eventName === "ViewContent") {
                  customData.content_name = "Ebook";
                  customData.content_type = "product";
          }
          fbq("track", options.eventName, customData, { eventID: eventId });
    } else {
          console.warn("[MetaCapi] fbq not available after 5s — pixel event not sent:", options.eventName);
    }

  // 2. CAPI via Supabase Edge Function (server-side deduplication via same eventId)
  try {
        const { error } = await supabase.functions.invoke("meta-capi", { body: payload });
        if (error) {
                console.warn("Meta CAPI error:", error.message);
        }
  } catch (err) {
        console.warn("Meta CAPI error:", err);
  }
}
